export enum EvvStatusHomeCareEnum {
    NotStarted = 0,
    InProgress = 1,
    Finished = 2,
    InProgressAdjusted = 3,
    FinishedAdjusted = 4
}
